import PT from 'prop-types';
import { Pill, enums } from 'edrolo-ui';
import { WORKING_PATHWAYS } from 'edrolo/domains/exams';
import { HotPepper, HotPepperGrey } from '../Icons';
import styles from './styles.scss';

export const WorkingPath = ({ workingPathways }) => {
  return (
    <>
      {workingPathways.length === 3 ? (
        <Pill
          variant={enums.PillVariant.OUTLINE}
          color={enums.ColorTheme.PRIMARY}
        >
          <HotPepperGrey />
          <span className={styles.label}>All working paths</span>
        </Pill>
      ) : (
        workingPathways.map((workingPathways, index) => (
          <Pill
            key={index}
            variant={enums.PillVariant.OUTLINE}
            color={enums.ColorTheme.PRIMARY}
          >
            {Array.from({ length: workingPathways }, (_, i) => (
              <HotPepper key={i} />
            ))}
            <span className={styles.label}>
              {WORKING_PATHWAYS[workingPathways]}
            </span>
          </Pill>
        ))
      )}
    </>
  );
};

WorkingPath.propTypes = {
  workingPathways: PT.arrayOf(PT.number),
};
